import produce from 'immer';
import {
  SET_DETAIL_TABLE,
  LOADER_STATUS,
  SET_FILE_DATA,
  SET_OTP_BOX,
  OTP_INVALID,
  SET_FILE_ERROR
} from './constants';

export const initialState = {
  loaderStatus: false,
  detailTable: false,
  fileData: [],
  isOtpActive: false,
  isOtpInvalid: false,
  fileError: false
};


const previewAndSubmitR3BReducer = (state = initialState, action) =>{
    switch (action.type) {

      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case SET_DETAIL_TABLE:
        return {
          ...state,
          detailTable:action.detailTable
        }
      case SET_FILE_DATA:
        return {
          ...state,
          fileData:action.fileData
        }
      case SET_OTP_BOX:
        return {
          ...state,
          isOtpActive:action.isOtpActive
        }
      case OTP_INVALID:
        return {
          ...state,
          isOtpInvalid:action.status
        }
      case SET_FILE_ERROR:
        return {
          ...state,
          fileError:action.status
        }
      default:
        return state;
    }
  };

export default previewAndSubmitR3BReducer;